import React from 'react';
import { Icons } from 'sarsaparilla';

const ContactCommercialAgency = () => (
  <div>
  <h1 className="h3 rec-questionnaire-result-what-you-need">
    You will need to...
  </h1>

    <div className="rec-questionnaire-result-title">
      Contact the Commercial Operator
    </div>

    <div className="rec-questionnaire-result-icon">
      <Icons.IconPermit />
    </div>

    <p>
      Contact the commercial operator that is providing the service. They will book the reservation for you.
    </p>
  </div>
);

ContactCommercialAgency.propTypes = {

};

export default ContactCommercialAgency;
